import { render, staticRenderFns } from "./SelectBackhaulType.vue?vue&type=template&id=038db2a5"
import script from "./SelectBackhaulType.vue?vue&type=script&lang=js"
export * from "./SelectBackhaulType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports